import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';
import moment from 'moment/moment';
import { PAGE_LOAD_STATUS, VIEWER_MODE } from './enums';
import { INIT_DOC_EMPTY_TAB, INIT_PAGE_PROPERTY, INIT_TAB_TOOLBAR, INIT_STATE } from './constans';

export const documentViewerSlice = createSlice({
    name: 'documentViewer',
    initialState: INIT_STATE,
    reducers: {
        setLoading: (state, loading) => {
            let loadingKey = _.get(loading.payload, 'loadingPart', 'main');
            _.set(state, `loading.${loadingKey}`, _.get(loading.payload, 'loading', false));
        },
        setViewerMode: (state, setMode) => {
            _.set(state, `mode`, _.get(setMode.payload, 'mode', VIEWER_MODE.DOC_VIEW));
        },
        setFilterPanelView: (state, setMode) => {
            _.set(state, `filter.panelVisible`, _.get(setMode.payload, 'visible', false));
        },
        setAllDocuments: (state, documents) => {
            const catalog = _.get(documents.payload, 'catalog', '');
            if (catalog !== '') {
                if (catalog !== _.get(state, 'catalogId', '')) {
                    _.set(state, 'catalogId', catalog);
                    _.set(state, 'attendances', []);
                    _.set(state, 'spells', []);
                    _.set(state, 'episodes', []);
                }
                _.set(state, 'allDocuments', _.get(documents.payload, 'docs', []));
            }
        },
        setAttendances: (state, attendances) => {
            const catalog = _.get(attendances.payload, 'catalog', '');
            if (catalog !== '') {
                if (catalog !== _.get(state, 'catalogId', '')) {
                    _.set(state, 'catalogId', catalog);
                    _.set(state, 'allDocuments', []);
                    _.set(state, 'spells', []);
                    _.set(state, 'episodes', []);
                }
                _.set(state, 'attendances', _.get(attendances.payload, 'attendances', []));
            }
        },
        setFilter: (state, setData) => {
            _.set(state, 'filter', setData.payload);
        },
        storeOpenTabs: (state, data) => {
            _.set(state, 'openTabs', data.payload);
        },
        setCurrentToolbarSet: (state, data) => {
            _.set(state, 'currentToolbarSet', data.payload);
        },
        setCurrentPageSet: (state, data) => {
            _.set(state, 'currentDocPageSet', data.payload);
        },
        setActivePage: (state, data) => {
            _.set(state, 'currentToolbarSet.activePage', data.payload.page);
        },
        setZoomPage: (state, setData) => {
            _.set(state, `currentDocPageSet.zoom`, setData.payload.zoom);
        },
        setToolbarSubData: (state, setData) => {
            _.set(state, `currentToolbarSet.wideViewSubData`, setData.payload.subData);
        },
        setPageMovedPosition: (state, setData) => {
            _.set(state, `currentDocPageSet.top`, setData.payload.top);
            _.set(state, `currentDocPageSet.left`, setData.payload.left);
        },
        setPageRotate: (state, setData) => {
            _.set(state, `currentDocPageSet.rotation`, setData.payload.rotate);
        },
        setPageReady: (state, setData) => {
            if (setData.payload.ready === PAGE_LOAD_STATUS.READY) {
                _.set(state, `currentDocPageSet.status`, PAGE_LOAD_STATUS.READY);
            }
        },
        addCurrentToolbarThumbnailPageData: (state, setData) => {
            const { docPageId, thumbData } = setData.payload;
            if (docPageId && thumbData) {
                _.set(state, `currentToolbarSet.thumbnailsData[${docPageId}]`, thumbData);
            }
        },
        setOpenDocument: (state, docData) => {
            const vId = _.get(docData.payload, 'viewerId', '');
            if (!_.isEmpty(vId)) {
                let tabIdx = _.findIndex(
                    _.get(state, vId, { tabs: [] }),
                    (t) => t.tabId === `tab_${_.get(docData.payload, 'doc.id', '0')}`,
                );
                if (tabIdx === -1) {
                    let newTab = _.cloneDeep(INIT_DOC_EMPTY_TAB);
                    newTab.tabId = `tab_${_.get(docData.payload, 'doc.id', '0')}`;
                    newTab.documentData = _.get(docData.payload, 'doc', {});
                    newTab.tabName = _.get(docData.payload, 'doc.originalFilename', 'no_name');
                    newTab.tabDocDate = moment(_.get(docData.payload, 'doc.date', ''), 'YYYY-MM-DDThh:mm:ssZ');
                    newTab.docType = _.get(docData.payload, 'doc.type.name', 'other');
                    newTab.docTab = _.get(docData.payload, 'doc.type.tabs[0].name', 'other');
                    newTab.docKind = _.get(docData.payload, 'doc.docKind', 'EMPTY');
                    newTab.toolbar = _.cloneDeep(INIT_TAB_TOOLBAR);
                    const pCount = _.get(docData.payload, 'doc.metadata.pageCount', 0);
                    newTab.pagesData = new Array(pCount);
                    newTab.toolbar.pages = new Array(pCount);
                    _.set(newTab, 'toolbar.pagesCount', pCount);
                    _.set(newTab, 'toolbar.activePage', pCount > 0 ? 1 : 0);
                    let tabs = _.get(state, `${vId}.tabs`, []);
                    tabIdx = _.size(tabs);
                    tabs.push(newTab);
                    _.set(state, `${vId}.tabs`, tabs);
                }
                _.set(state, `${vId}.activeTab`, tabIdx);
            } else {
                console.debug('setOpenDocument viewerId missing', docData.payload);
            }
        },
        closeDocumentTab: (state, docData) => {
            const vId = _.get(docData.payload, 'viewerId', '');
            if (!_.isEmpty(vId)) {
                const tabId = _.get(docData.payload, 'tabId', '');
                if (tabId !== '') {
                    let tabsArr = _.get(state, `${vId}.tabs`, []);
                    let tabIdx = _.findIndex(tabsArr, (t) => t.tabId === tabId);
                    if (tabIdx > -1 && Array.isArray(tabsArr)) {
                        const activeT = _.get(state, `${vId}.activeTab`, -1);
                        let oldActiveTabId = '';
                        if (activeT > -1) {
                            oldActiveTabId = _.get(tabsArr, `[${activeT}].tabId`, '');
                        }
                        let tmpArr = [..._.cloneDeep(tabsArr)];
                        _.pullAt(tmpArr, [tabIdx]);
                        _.set(state, `${vId}.tabs`, tmpArr);
                        if (oldActiveTabId !== '') {
                            if (_.isEqual(oldActiveTabId, tabId)) {
                                _.set(state, `${vId}.activeTab`, -1);
                            } else {
                                _.set(
                                    state,
                                    `${vId}.activeTab`,
                                    _.findIndex(tmpArr, (t) => t.tabId === oldActiveTabId),
                                );
                            }
                        }
                    } else {
                        console.debug('tabId for remove not found', docData.payload);
                    }
                } else {
                    console.debug('tabId missing in payload', docData.payload);
                }
            } else {
                console.debug('setOpenDocument viewerId missing', docData.payload);
            }
        },
        setActiveTab: (state, setData) => {
            const vId = _.get(setData.payload, 'viewerId', '');
            if (!_.isEmpty(vId)) {
                const tabIdx = _.findIndex(
                    _.get(state, `${vId}.tabs`, { tabs: [] }),
                    (t) => t.tabId === _.get(setData.payload, 'tabId', 'tab_'),
                );
                if (tabIdx === -1) {
                    console.debug('setActiveTab viewerId cant find idx for tabId', setData.payload);
                } else {
                    _.set(state, `${vId}.activeTab`, tabIdx);
                }
            } else {
                console.debug('setActiveTab viewerId missing', setData.payload);
            }
        },
        setWideView: (state, setData) => {
            const vVector = getViewerActiveTabAndPage(state, setData.payload, 'setWideView');
            if (!_.isEmpty(vVector[0]) && vVector[1] !== -1) {
                const wideView = _.get(setData.payload, 'wideView', false);
                _.set(state, `${vVector[0]}.tabs[${vVector[1]}].toolbar.wideView`, wideView);
                _.set(state, `${vVector[0]}.tabs[${vVector[1]}].toolbar.subData`, wideView ? _.get(setData.payload, 'subData', '') : '');
            }
        },
        setRotatePage: (state, setData) => {
            const vVector = getViewerActiveTabAndPage(state, setData.payload, 'setRotatePage');
            if (!_.isEmpty(vVector[0]) && vVector[2] > -1) {
                let page = _.get(state, `${vVector[0]}.tabs[${vVector[1]}].toolbar.pages[${vVector[2]}]`, INIT_PAGE_PROPERTY);
                _.set(page, 'rotation', (page.rotation + _.get(setData.payload, 'rotate', 0)) % 360);
                _.set(state, `${vVector[0]}.tabs[${vVector[1]}].toolbar.pages[${vVector[2]}]`, page);
            }
        },

        setViewFilter: (state, setData) => {
            const vId = _.get(setData.payload, 'viewerId', '');
            if (!_.isEmpty(vId)) {
                _.set(state, `${vId}.viewFilter`, _.get(setData.payload, 'viewFilter', 'all'));
            }
        },
        setAddPageData: (state, setData) => {
            const vVector = getViewerActiveTabAndPage(state, setData.payload, 'setAddPageData');
            if (!_.isEmpty(vVector[0]) && vVector[2] > -1) {
                const pagesCount = _.get(state, `${vVector[0]}.tabs[${vVector[1]}].toolbar.pagesCount`, -1);
                if (pagesCount && pagesCount > -1) {
                    let pagesData = _.get(state, `${vVector[0]}.tabs[${vVector[1]}].pagesData`, new Array(pagesCount));
                    if (Array.isArray(pagesData) && vVector[2] > 0 && vVector[2] <= pagesCount) {
                        pagesData[vVector[2] - 1] = _.get(setData.payload, 'pageData', null);
                        _.set(state, `${vVector[0]}.tabs[${vVector[1]}].pagesData`, pagesData);
                    }
                    let pages = _.get(state, `${vVector[0]}.tabs[${vVector[1]}].toolbar.pages`, new Array(pagesCount));
                    if (Array.isArray(pages) && vVector[2] > 0 && vVector[2] <= pagesCount) {
                        pages[vVector[2] - 1] = _.get(setData.payload, 'pageToolbarProperty', INIT_PAGE_PROPERTY);
                        _.set(state, `${vVector[0]}.tabs[${vVector[1]}].toolbar.pages`, pages);
                    }
                }
            }
        },
        setPageMovementPosition: (state, setData) => {
            const vVector = getViewerActiveTabAndPage(state, setData.payload, 'setPageMovementPosition');
            if (!_.isEmpty(vVector[0]) && vVector[2] > -1) {
                let page = _.get(state, `${vVector[0]}.tabs[${vVector[1]}].toolbar.pages[${vVector[2] - 1}]`, INIT_PAGE_PROPERTY);
                _.set(page, 'top', _.get(setData.payload, 'top', 0));
                _.set(page, 'left', _.get(setData.payload, 'left', 0));
                if (_.get(setData.payload, 'changeRenderVer', false)) {
                    page.pageRenderVer++;
                }
                _.set(state, `${vVector[0]}.tabs[${vVector[1]}].toolbar.pages[${vVector[2] - 1}]`, page);
            }
        },
    },
});

//Helper functions
const getViewerActiveTabAndPage = (state, payload, fnName) => {
    const vId = _.get(payload, 'viewerId', '');
    if (!_.isEmpty(vId)) {
        const actTab = _.get(state, `${vId}.activeTab`, -1);
        const activePage = _.get(state, `${vId}.tabs[${actTab}].toolbar.activePage`, -1);
        return [vId, actTab, activePage];
    } else {
        console.debug(`${fnName} viewerId missing`, payload);
    }
    return ['', -1, -1];
};

// Setters
export const {
    setLoading,
    setViewerMode,
    setFilterPanelView,
    setAllDocuments,
    setAttendances,
    // setSpells,
    // setEpisodes,
    storeOpenTabs,

    setCurrentToolbarSet,
    setCurrentPageSet,
    setPageReady,
    setZoomPage,
    setToolbarSubData,
    setPageMovedPosition,
    setPageRotate,
    addCurrentToolbarThumbnailPageData,

    setOpenDocument,
    closeDocumentTab,
    setActivePage,
    setActiveTab,
    setWideView,
    setRotatePage,

    setViewFilter,
    setAddPageData,
    setPageMovementPosition,
} = documentViewerSlice.actions;

// Variable
export const catalogId = (state) => state.documentViewer.catalogId;
export const catalogDocuments = (state) => state.documentViewer.allDocuments;
export const catalogAttendances = (state) => state.documentViewer.attendances;
export const catalogSpells = (state) => state.documentViewer.spells;
export const catalogEpisodes = (state) => state.documentViewer.episodes;
export const viewerMode = (state) => state.documentViewer.mode;
export const activeViewerWindow = (state) => state.documentViewer.activeWindow;
export const activeTabId = (state) => state.documentViewer.activeTabId;
export const openTabs = (state) => state.documentViewer.openTabs;
export const panelFilter = (state) => _.get(state, 'documentViewer.filter.panelVisible', false);

//OLD AND DEPRECATED
//viewer0  variables
export const viewer_0_tabs = (state) => state.documentViewer.viewer_0.tabs;
export const viewer_0_activeTab = (state) => state.documentViewer.viewer_0.activeTab;
export const viewer_0_activeTabId = (state) => {
    if (
        state.documentViewer.viewer_0.activeTab > -1 &&
        state.documentViewer.viewer_0.tabs.length > state.documentViewer.viewer_0.activeTab
    ) {
        return _.get(state.documentViewer.viewer_0.tabs[state.documentViewer.viewer_0.activeTab], 'tabId', '');
    } else {
        return -1;
    }
};
export const viewer_0_activeTabDocId = (state) => {
    if (
        state.documentViewer.viewer_0.activeTab > -1 &&
        state.documentViewer.viewer_0.tabs.length > state.documentViewer.viewer_0.activeTab
    ) {
        return _.get(state.documentViewer.viewer_0.tabs[state.documentViewer.viewer_0.activeTab], 'documentData.id', '');
    }
};
export const viewer_0_activeTab_currentTab_toolbar = (state) => {
    const tab = _.get(state.documentViewer.viewer_0.tabs, state.documentViewer.viewer_0.activeTab, { toolbar: INIT_TAB_TOOLBAR });
    return _.get(tab, 'toolbar', INIT_TAB_TOOLBAR);
};
export const viewer_0_activeTab_currentPage = (state) => {
    const tab = _.get(state.documentViewer.viewer_0.tabs, state.documentViewer.viewer_0.activeTab, { toolbar: INIT_TAB_TOOLBAR });
    return _.get(tab, 'toolbar.activePage', -1);
};
export const viewer_0_activeTab_pagesCount = (state) => {
    const tab = _.get(state.documentViewer.viewer_0.tabs, state.documentViewer.viewer_0.activeTab, { toolbar: INIT_TAB_TOOLBAR });
    return _.get(tab, 'toolbar.pagesCount', -1);
};
export const viewer_0_activeTab_wideView = (state) => {
    const tab = _.get(state.documentViewer.viewer_0.tabs, state.documentViewer.viewer_0.activeTab, { toolbar: INIT_TAB_TOOLBAR });
    return _.get(tab, 'toolbar.wideView', false);
};
export const viewer_0_activeTab_subData = (state) => {
    const tab = _.get(state.documentViewer.viewer_0.tabs, state.documentViewer.viewer_0.activeTab, { toolbar: INIT_TAB_TOOLBAR });
    return _.get(tab, 'toolbar.subData', false);
};
export const viewer_0_viewFilter = (state) => {
    return _.get(state, 'documentViewer.viewer_0.viewFilter', 'all');
};
//viewer1 variables
//viewer2 variables
//viewer3 variables

export default documentViewerSlice.reducer;
